export function validatePhoneNumber(phoneNumber: string): boolean {
  if (phoneNumber.match(/[a-zA-Z]/)) {
    return false;
  }
  const onlyNumbers = phoneNumber.replace(/\D/g, '');
  return onlyNumbers.length === 10 || (onlyNumbers[0] === '1' && onlyNumbers.length === 11);
}
